import "./template_journal.css";
